<template>
    <div class="loader-stage">
        <!-- Center icon spinning in place -->
        <div class="center-icon">
            <svg viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3839 16.2135C20.7634 14.7641 21.9746 13.4157 23.5223 11.9326C25.0699 10.4832 26.2139 9.3708 26.954 8.59551C27.0886 8.46068 27.2905 8.5281 27.5597 8.83147C27.9634 9.26967 28.9727 10.3146 29.1746 10.5169C29.3765 10.7191 29.6793 10.9888 30.0494 11.3596C30.4531 11.7303 30.7559 12 30.9578 12.2023C31.1597 12.4045 31.1933 12.573 31.0251 12.7079C30.2849 13.4495 29.1073 14.5618 27.5933 16.045C26.0456 17.4944 24.8344 18.8764 23.455 20.3259C22.0755 21.7753 20.9989 22.854 20.2923 23.5618C20.1241 23.7304 19.9222 23.7304 19.7204 23.5618C19.1484 23.0562 18.711 22.6517 18.4082 22.3483L15.9521 19.6854C15.9521 19.6854 15.8848 19.5169 15.9521 19.4495C16.4232 18.9775 18.1727 17.4607 19.3839 16.2472V16.2135Z"
                    fill="currentColor"
                />
                <path
                    d="M14.4382 20.7978C14.0008 21.1686 13.6644 21.5056 13.4288 21.7079C13.227 21.9101 12.9578 22.2135 12.6214 22.618C12.2513 23.0225 11.9821 23.3259 11.7802 23.5281C11.5784 23.7304 11.4101 23.7304 11.2756 23.5955C10.5017 22.8203 0.845616 13.2135 0.139071 12.4719C-0.0627988 12.3034 -0.0291538 12.1011 0.139071 11.8989C0.374586 11.6629 0.542811 11.427 0.744681 11.2247C0.946551 10.9551 1.18207 10.7528 1.31665 10.5843C1.31665 10.5843 1.38394 10.5169 1.48487 10.4495C3.77273 8.15731 10.6027 1.34832 11.4438 0.37079L11.5784 0.235958C11.5784 0.235958 11.7802 0.0674185 11.8812 0.168542C12.083 0.37079 12.3858 0.707869 12.8232 1.14607C13.227 1.58427 13.5298 1.92135 13.7316 2.15731C13.9335 2.35956 14.2363 2.62922 14.6064 3.00001C14.9429 3.26967 15.1784 3.50562 15.3466 3.70787C15.3466 3.70787 15.4475 3.70787 15.4812 3.70787C16.9279 2.25843 18.2401 0.943824 18.7111 0.438205L18.812 0.303374C18.812 0.303374 19.0475 0.168542 19.1148 0.235958C19.3167 0.438205 19.6195 0.775284 20.0233 1.2472C20.427 1.6854 20.7298 2.02248 20.9653 2.22472C21.1672 2.42697 21.47 2.69663 21.8737 3.06742C22.2775 3.43821 22.5803 3.70787 22.7485 3.91012C22.8494 4.01124 22.8158 4.21349 22.7485 4.28091L22.6476 4.41574C21.47 5.73035 15.8513 11.9326 15.4475 12.3371C15.3802 12.4045 15.2793 12.4719 15.212 12.5393C15.1111 12.6068 15.0102 12.6068 14.9092 12.5393L14.6737 12.3034C14.1017 11.7304 12.3186 9.43822 11.7466 8.86518C11.5447 8.66293 11.4101 8.66293 11.2419 8.83147C10.1316 9.94383 9.25686 10.9888 8.61761 11.9663C8.48303 12.1686 8.44938 12.3371 8.51667 12.4719C8.51667 12.5056 8.65125 12.6405 8.88677 12.8764C9.45873 13.4495 14.169 18.0337 14.169 18.0337C14.3709 18.236 15.212 19.1124 15.5485 19.4158C15.6158 19.4832 15.6158 19.5506 15.5485 19.618C15.313 19.8877 14.6064 20.5955 14.4045 20.7978H14.4382Z"
                    fill="currentColor"
                />
            </svg>
        </div>

        <!-- Comet arc ring (conic-gradient) -->
        <div class="comet-ring" />
        <!-- Bright head dot outside the masked ring -->
        <div class="comet-head-orbit">
            <div class="comet-head-dot" />
        </div>
    </div>
</template>

<script>
export default {
    name: "LoaderV3",
};
</script>

<style scoped lang="scss">
@import "@/sass/commons/_variables";

$orbit-size: 108px;
$icon-size: 38px;
$thickness: 7px;
$comet: #ee8c4f;
$duration: 1.1s;

.loader-stage {
    position: relative;
    width: 148px;
    height: 148px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

// Spinning center logo
.center-icon {
    position: absolute;
    width: $icon-size;
    height: $icon-size;
    color: $primary-color;
    z-index: 2;
    animation: iconSpin $duration * 2 linear infinite;

    svg {
        width: 100%;
        height: 100%;
    }
}

// Comet arc: bright head at 0deg, tail fades clockwise to transparent.
// mask punches out the center leaving only the ring strip.
.comet-ring {
    position: absolute;
    width: $orbit-size;
    height: $orbit-size;
    border-radius: 50%;
    background: conic-gradient(
        from 0deg,
        $comet 0deg,
        rgba($comet, 0.55) 50deg,
        rgba($comet, 0.2) 110deg,
        rgba($comet, 0.05) 170deg,
        transparent 230deg,
        transparent 360deg
    );
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - #{$thickness}), #000 calc(100% - #{$thickness} + 1px));
    mask: radial-gradient(farthest-side, transparent calc(100% - #{$thickness}), #000 calc(100% - #{$thickness} + 1px));
    animation: cometSpin $duration linear infinite;
}

// Head dot outside the masked ring so it isn't clipped
.comet-head-orbit {
    position: absolute;
    width: $orbit-size;
    height: $orbit-size;
    border-radius: 50%;
    animation: cometSpin $duration linear infinite;
}

.comet-head-dot {
    $dot-size: 12px;

    position: absolute;
    width: $dot-size;
    height: $dot-size;
    border-radius: 50%;
    background: $comet;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
}

@keyframes cometSpin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes iconSpin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
